import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectPeopleAvailable = createSelector(
  [
    (store: RootState) => store.massNotification.peopleList,
    (store: RootState) => store.massNotification.selectedPeople,
    (store: RootState) => store.massNotification.searchText,
    (store: RootState) => store.massNotification.createFilters,
    (store: RootState) => store.massiveDocumentCreate.locations,
  ],
  (peopleList, selectedPeople, searchText, createFilters, stateLocations) =>
    peopleList?.filter(({ name, location, id }) => {
      if (selectedPeople.find(({ id: selectedUserId }) => selectedUserId === id)) {
        return false;
      }
      if (searchText && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())) {
        return false;
      }

      if (
        createFilters.location.id &&
        !stateLocations
          .filter(({ partOf }) => partOf)
          .filter(({ partOf }) => partOf.id === createFilters.location?.id)
          .find(({ id }) => id === location?.id)
      ) {
        return false;
      }

      if (createFilters.range) {
        let count: number[] = [];
        let hyphenSplit: string[][] = [];
        const commaSplit = createFilters.range.split(",");
        commaSplit.forEach((t) => hyphenSplit.push(t.split("-")));
        hyphenSplit.forEach((item) => {
          for (let index = +item[0]; index <= +item[1]; index++) {
            count.push(index);
          }
        });

        if (
          createFilters.location.id &&
          location?.code &&
          !count.includes(+location?.code.substring(location.code.length - 3))
        ) {
          return false;
        }
      }
      return true;
    }) || []
);
